// extracted by mini-css-extract-plugin
export var active = "_23-7";
export var backButton = "_23-6";
export var clone = "_23-c";
export var collapseBar = "_23-g";
export var collapseMode = "_23-i";
export var dragHandle = "_23-a";
export var dropdownIcon = "_23-e";
export var hidden = "_23-o";
export var iconContainer = "_23-l";
export var iconSwapper = "_23-n";
export var navItem = "_23-4";
export var navItemIcon = "_23-d";
export var navProfile = "_23-5";
export var notificationDot = "_23-m";
export var optionsContainer = "_23-f";
export var primaryNav = "_23-0";
export var primaryTab = "_23-j";
export var secondaryNav = "_23-1";
export var selected = "_23-k";
export var settingsNav = "_23-2";
export var settingsNavItems = "_23-3";
export var show = "_23-b";
export var sideNav = "_23-h";
export var teamItem = "_23-8";
export var userProfileItem = "_23-9";